import { FormattedMessage } from 'react-intl';
import React from 'react';

export const tariffsColumns = {
  tariff: {
    id: 'tariff',
    label: <FormattedMessage id={'app.contract.tariff'} />,
    options: {
      sortable: true,
    },
    width: '150px',
  },
};

const tariffLabel = (id) => (<><FormattedMessage id={'app.transactions.tariff'} /> {id}</>);

export const transactionsColumns = {
  createdAt: {
    id: 'createdAt',
    label: <FormattedMessage id={'app.transactions.createdAt'} />,
    align: 'left',
    options: {
      sortable: true,
    },
    width: '120px',
  },
  exchangeProductName: {
    id: 'exchangeProductName',
    label: <FormattedMessage id={'app.transactions.product'} />,
    align: 'left',
    options: {
      sortable: true,
    },
    width: '150px',
  },
  purchaseType: {
    id: 'purchaseType',
    label: <FormattedMessage id={'app.transactions.purchaseType'} />,
    align: 'left',
    width: '95px',
  },
  priceSource: {
    id: 'priceSource',
    label: <FormattedMessage id={'app.transactions.priceSource'} />,
    align: 'left',
    width: '90px',
  },
  rate: {
    id: 'rate',
    label: <FormattedMessage id={'app.transactions.rate'} />,
    align: 'right',
    width: '40px',
  },
  price: {
    id: 'price',
    label: <FormattedMessage id={'app.transactions.price'} />,
    align: 'right',
    options: {
      sortable: true,
    },
    width: '160px',
  },
  quantity: {
    id: 'quantity',
    label: <FormattedMessage id={'app.transactions.quantity'} />,
    align: 'right',
    options: {
      sortable: true,
    },
    width: '90px',
  },
  tariff1: {
    id: 'tariff1',
    label: tariffLabel(1),
    width: '60px',
    align: 'right',
  },
  tariff2: {
    id: 'tariff2',
    label: tariffLabel(2),
    width: '60px',
    align: 'right',
  },
  tariff3: {
    id: 'tariff3',
    label: tariffLabel(3),
    width: '60px',
    align: 'right',
  },
  tariff4: {
    id: 'tariff4',
    label: tariffLabel(4),
    width: '60px',
    align: 'right',
  },
  tariff5: {
    id: 'tariff5',
    label: tariffLabel(5),
    width: '60px',
    align: 'right',
  },
  tariff6: {
    id: 'tariff6',
    label: tariffLabel(6),
    width: '60px',
    align: 'right',
  },
};
